import { useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import useGetVsic from '../../../../../../common/category/useGetVsic'
import { TextEllipsisStaticLine } from '../../../../../../common/textEllipsis/TextEllipsisStaticLine'
import { formatText, formatVal } from '../../../../../../helpers/value'
import { MAP_KEY_TITLE } from '../../constant'
import { CustomCell } from './CustomCell'

export const RowGroup = ({
  rowId,
  rowGroupIndex,
  schema,
  selectRowGroup,
  selectCellData,
  isDynamicReport,
  typeComponent,
  compareVal,
}) => {
  const locale = useSelector((state) => state.i18n.locale)
  const rowGroup = useSelector(selectRowGroup(compareVal, typeComponent, rowId))
  const { vsics } = useGetVsic()

  const getFormatVal = (colId, format) => {
    return (val) => {
      switch (colId) {
        case 'typeGroup':
          return (
            <TextEllipsisStaticLine
              text={formatText(MAP_KEY_TITLE[val])}
              isI18n
            />
          )
        case 'vsicId':
          const text = vsics.find((item) => item.id === val)?.name
          return (
            <Translate
              value={'companyAnalysis.industryAnalysis.INDUSTRY'}
              industry={text || ''}
            />
          )

        default:
          return format ? format(val) : formatVal(val, locale)
      }
    }
  }

  const renderContent = (rowIndex) => {
    return schema
      .slice(rowIndex === 0 ? 0 : 1)
      .map(({ colId, format }, colIndex) => {
        return (
          <CustomCell
            key={colIndex}
            rowSpan={colIndex === 0 && rowIndex === 0 ? rowGroup.length : 1}
            rowId={rowId}
            colIndex={colIndex}
            colId={colId}
            rowIndex={rowIndex}
            selectCellData={selectCellData}
            format={getFormatVal(colId, format)}
            typeComponent={typeComponent}
            compareVal={compareVal}
          />
        )
      })
  }

  const getBgColor = () => {
    if (isDynamicReport) {
      return rowGroupIndex % 2 === 0 ? '#F9F9F9' : '#FFFFFF'
    }
    return rowGroupIndex % 2 === 0 ? '#F9F9F9' : '#FFFFFF'
  }

  return rowGroup.map((_, rowIndex) => {
    return (
      <tr
        key={rowIndex}
        style={{
          borderBottom: rowIndex === rowGroup.length - 1 && '1px solid #D5D5D5',
          backgroundColor: getBgColor(),
        }}
      >
        {renderContent(rowIndex)}
      </tr>
    )
  })
}
